export default "__VITE_ASSET__Bel1ApDw__"